<template>
    <b-nav-item-dropdown
        data-top-right-id="recents"
        id="nav-item-audit"
        @show="logClicked"
        no-caret
        right
    >
        <template slot="button-content">
            <i class="fas fa-bolt page_white_lightning"></i>
            <span class="d-lg-none">Recent</span>
        </template>
        <b-dropdown-item
            @click="goToPage(log)"
            v-for="log in filteredLogs"
            :key="log.id"
        >
            <div class="item">
                <module-icon :name="log.sub_module" class="icon" />
                <div class="content">
                    <div>{{ log.text }}</div>
                    <div class="module">
                        {{ capitalizeFirstLetter(log.sub_module) }}
                    </div>
                </div>
            </div>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>
<script>
import ModuleIcon from "@/module/layout/module-icon";

export default {
    components: {
        ModuleIcon
    },
    data() {
        return {
            businesses: [],
            logs: [],
            currentActor: null,
            setting: {}
        };
    },
    computed: {
        filteredLogs() {
            let logs = this.logs;
            let currentPath = this.$router.currentRoute.fullPath;
            let bid = this.$root.setting.business_id;

            // ensure list appears based on current business id (vet-1320)
            if (bid) {
                logs = logs.filter(item => item.business_id === bid);
            }

            if (logs.length > 0) {
                if (logs[0].url.includes(currentPath)) {
                    return logs.slice(1, 11);
                }
            }

            return logs.slice(0, 10);
        }
    },
    methods: {
        async getLogs() {
            let url = process.env.ACCOUNT_SERVICE + "recent-viewed-pages";
            let res = await this.$http.get(url);
            this.logs = res.data.response.resources;
        },
        logClicked() {
            this.getLogs();
        },
        capitalizeFirstLetter(word) {
            if (!word) return "";
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        checkUrl(url) {
            if (url) {
                if (url.charAt(0) === "/") {
                    return url.substring(1);
                }
            }
            return url;
        },
        goToPage(log) {
            if (
                log.module === "patient" &&
                !log.url.includes("index.php") &&
                !this.USE_PATIENT_MODULE_VUE
            ) {
                let patientEncodedId = log.url.split("/")[4];
                window.location.href = process.env.APPS + "patient/patient/view/" + patientEncodedId; // prettier-ignore
            } else if (
                log.module === "patient" &&
                log.url.includes("index.php") &&
                this.USE_PATIENT_MODULE_VUE
            ) {
                if (log.sub_module && log.sub_module == "lab") {
                    // this when lab view have enable
                    // let labId = log.reference_id.split(";")[1];
                    // this.$router.push({
                    //     name: "lab",
                    //     params: { id: labId }
                    // });
                    window.location.href =
                        process.env.APPS + this.checkUrl(log.url);
                } else {
                    let patientEncodedId = log.url.split("/")[5];
                    this.$router.push({
                        name: "patient_profile",
                        params: { id: patientEncodedId }
                    });
                }
            } else if (log.url.includes("../view")) {
                let newUrl = log.url.replace("../view", "");
                this.$router.push({ path: newUrl });
            } else {
                window.location.href =
                    process.env.APPS + this.checkUrl(log.url);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.item {
    display: flex;
    gap: 8px;
    align-items: flex-start;

    .icon {
        width: 20px;
        height: auto;
    }

    .module {
        font-size: 0.8em;
        font-weight: normal;
        color: #4a4a4a;
    }
}
</style>
